import { MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React, { memo } from 'react';
import { MediaContactsProps } from './MediaContacts.interface';
import useStyles from './MediaContacts.styles';

const Contact = ({ name, company, title, email, phoneNumber: phone, classes }: any) => {
  return (
    <div className={classes.contact}>
      {name && (
        <MuiTypography variant="body1" color="inherit">
          {name}
        </MuiTypography>
      )}
      {(company || title) && (
        <MuiTypography variant="body1" color="inherit" component="div">
          {company && <span>{company}</span>}
          {company && title && <span> | </span>}
          {title && <span>{title}</span>}
        </MuiTypography>
      )}
      {email && (
        <MuiTypography
          variant="body1"
          color="inherit"
          component="a"
          href={`mailto:${email}`}
          className={classes.contactEmail}
        >
          {email}
        </MuiTypography>
      )}
      {phone && (
        <MuiTypography
          variant="body1"
          component="a"
          href={`tel:${phone}`}
          color="inherit"
          className={classes.contactPhone}
        >
          {phone}
        </MuiTypography>
      )}
    </div>
  );
};

const MediaContactTitle = ({ section, classes }: any) => {
  return (
    <MuiTypography variant="h4" color="inherit" className={classes.mediaContactTitle}>
      {section}
    </MuiTypography>
  );
};

const MediaContactRegionTitle = ({ title, classes }: any) => {
  return (
    <MuiTypography
      variant="overline"
      color="inherit"
      component="div"
      className={classes.regionTitle}
    >
      {title}
    </MuiTypography>
  );
};

const MediaContacts = ({ mediaContacts, theme }: MediaContactsProps) => {
  const classes = useStyles({});
  const rootClassName = clsx(classes.root, `${theme}-theme`);

  if (!mediaContacts) return null;

  return (
    <div className={rootClassName}>
      {mediaContacts.map(({ region, section, mediaContact }: any, id) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={`${region}_${id}`}>
          {section && <MediaContactTitle section={section} classes={classes} />}
          {region && <MediaContactRegionTitle title={region} classes={classes} />}
          {mediaContact &&
            mediaContact.map((contact: any, i: number) => (
              // eslint-disable-next-line react/no-array-index-key
              <Contact key={`${contact.name}_${i}`} {...contact} classes={classes} />
            ))}
        </div>
      ))}
    </div>
  );
};

export default memo(MediaContacts);
